import { render } from "./App.vue?vue&type=template&id=3f2d55b1&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=3f2d55b1&lang=scss&scoped=true"

import exportComponent from "/Users/n0x/w4_proj/zigmodu_ws/heysen_saas/site/datax/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2d55b1"]])

export default __exports__